<button mat-icon-button class="navbar-btn">
    <mat-icon>menu</mat-icon>
</button>
